export default "__VITE_ASSET__BRngnY4___"